import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {Router} from '@angular/router';

import {StorageService} from '../../../services/storage.service';
import {PlaidOAuth} from '../../models/OAuth/PlaidOAuth.model';
import {OAuth} from '../../models/OAuth/OAuth.model';
import {LoggerService} from '../../errors/logger.service';
import {OAuthProvider} from '../../models/OAuth/OAuthProvider.enum';
import {TerraUtils} from '../../TerraUtils';

@Component({
  selector: 'terra-oauth',
  template: ``,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OauthComponent implements OnInit {

  constructor(private storageService: StorageService,
              private router: Router,
              private logger: LoggerService) { }

  ngOnInit(): void {
    try {
      const oauthData = this.storageService.getPersistent<OAuth>(TerraUtils.consts.OAUTH_LOCAL_STORAGE_KEY);
      switch (oauthData.provider) {
        case OAuthProvider.Plaid:
          this.onPlaidOAuth(oauthData as PlaidOAuth);
          break;
        default:
          this.logger.error('A user reached OAuth landing page without oauth provider', oauthData);
          // return to default page
          this.router.navigate(['/'], { replaceUrl: true });
      }
    } catch (error) {
      this.logger.error('Error redirecting from OAuth', error, error?.message);
      this.router.navigate(['/'], { replaceUrl: true });
    }
  }

  private onPlaidOAuth(plaidOAuthData: PlaidOAuth) {
    plaidOAuthData.receivedRedirectUri = window.location.href;
    this.storageService.setPersistent(TerraUtils.consts.OAUTH_LOCAL_STORAGE_KEY, plaidOAuthData);
    this.router.navigate([plaidOAuthData.originPath], {queryParamsHandling: 'preserve', replaceUrl: true});
  }
}
